import Component from '../component';

export default class ReferencesFilters extends Component {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/references-filters/references-filters.js